import React from 'react'
import { BaseView } from '@/components/base'
import { GoalItem } from '@/components/GoalItem'
import { useSavingsStore } from '@/store/useSavingsStore'
import { goals, Goal } from '@/mock/goals'
import { useAppAnalytics } from '@/services/analytics'

interface GoalsListProps {
  style?: React.CSSProperties
}

export const GoalsList: React.FC<GoalsListProps> = ({ style }) => {
  const setGoal = useSavingsStore((state) => state.setGoal)
  const selectedGoal = useSavingsStore((state) => state.goal)
  const { trackEvent, events } = useAppAnalytics()

  const handleGoalSelect = (goal: Goal) => {
    trackEvent(events.SAVINGS_STARTED, {
      entry_point: 'goals_list',
    })
    setGoal({
      category: goal.emoji,
      name: goal.name,
    })
  }

  return (
    <BaseView
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '12px',
        // padding: '20px 0',
        width: '100%',
        maxWidth: '100%',
        ...style,
      }}
    >
      {goals.map((goal) => (
        <BaseView
          key={goal.id}
          style={{
            width: '100%',
            aspectRatio: '1',
          }}
        >
          <GoalItem
            emoji={goal.emoji}
            onPress={() => handleGoalSelect(goal)}
            isSelected={selectedGoal?.category === goal.emoji}
          />
        </BaseView>
      ))}
    </BaseView>
  )
}
